import Alert from 'bootstrap/js/src/alert.js';
import Button from 'bootstrap/js/src/button.js';
import Carousel from 'bootstrap/js/src/carousel.js';
import Collapse from 'bootstrap/js/src/collapse.js';
import Dropdown from 'bootstrap/js/src/dropdown.js';
import Modal from 'bootstrap/js/src/modal.js';
import Offcanvas from 'bootstrap/js/src/offcanvas.js';
import Popover from 'bootstrap/js/src/popover.js';
import ScrollSpy from 'bootstrap/js/src/scrollspy.js';
import Tab from 'bootstrap/js/src/tab.js';
import Toast from 'bootstrap/js/src/toast.js';
import Tooltip from 'bootstrap/js/src/tooltip.js';

import Confirm from './confirm';
import DynamicModal from './dynamic-modal';

// Initialize tooltips
document
  .querySelectorAll('[data-bs-toggle="tooltip"]')
  .forEach((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

// Initialize toasts
document
  .querySelectorAll('.toast')
  .forEach((toastEl) => (new Toast(toastEl)).show());

// Initialize confirms
document
  .querySelectorAll('[data-confirm]')
  .forEach((confirmEl) => new Confirm(confirmEl));

// Initialize dynamic modals for TOS
const termsLink = document.querySelector('.terms-popup');
if (termsLink) new DynamicModal(termsLink, { title: 'Terms & Conditions' });

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
  Confirm,
  DynamicModal,
};
